function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.627,
    height: 11.046,
    viewBox: "0 0 11.627 11.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3001",
    "data-name": "Group 3001",
    transform: "translate(0 -12.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "history",
    transform: "translate(0 12.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M6.1,12.75a5.429,5.429,0,0,0-4.767,2.79L0,14.2v3.779H3.779L2.151,16.354a4.384,4.384,0,1,1-.174,3.372H.756A5.532,5.532,0,1,0,6.1,12.75Zm-.872,2.907v2.965l2.732,1.628.465-.756L6.1,18.1V15.657Z",
    transform: "translate(0 -12.75)",
    opacity: 0.9,
    style: {
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryicon);
export default __webpack_public_path__ + "static/media/historyicon.35669c0f432ecad4e8ba702f3b9b0da9.svg";
export { ForwardRef as ReactComponent };